import AppHeader from 'components/AppHeader'

export default {
  name: 'propose-detail',
  created () {
    this.search()
  },
  data () {
    return {
      canValidate: true,
      searchCallbackFlag: false,
      isOpenModal: false,
      adoptedReason: {
        content: ''
      },
      ranks: [
        { name: '採用検討', value: 'considerating' },
        { name: 'テスト採用', value: 'testing' },
        { name: '採用', value: 'adopted' }
      ],
      selectedRank: null
    }
  },
  computed: {
    proposeDetail () {
      return this.$store.getters.proposeDetail
    },
    joint1User () {
      return this.$store.getters.joint1User
    },
    joint2User () {
      return this.$store.getters.joint2User
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    },
    peaceMing () {
      return !!this.proposeDetail.attributes['idea-peace-ming']
    },
    sincere () {
      return !!this.proposeDetail.attributes['idea-sincere']
    },
    excitement () {
      return !!this.proposeDetail.attributes['idea-excitement']
    },
    comfortable () {
      return !!this.proposeDetail.attributes['idea-comfortable']
    },
    creation () {
      return !!this.proposeDetail.attributes['idea-creation']
    },
    civility () {
      return !!this.proposeDetail.attributes['idea-civility']
    },
    imagination () {
      return !!this.proposeDetail.attributes['idea-imagination']
    },
    sympathy () {
      return !!this.proposeDetail.attributes['idea-sympathy']
    },
    expression () {
      return !!this.proposeDetail.attributes['idea-expression']
    },
    challengeDream () {
      return !!this.proposeDetail.attributes['idea-challenge-dream']
    },
    validation: function () {
      return {
        adopt_rank: !!this.selectedRank,
        adopt_content: !!this.adoptedReason.content
      }
    },
    adoptedReasonContentCount: function () {
      return this.adoptedReason.content.length
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      var data = {}
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
        self.selectedRank = self.proposeDetail.attributes['adopt-rank']
        self.adoptedReason.content = (self.proposeDetail.attributes['adopt-content'] !== null)
                                     ? self.proposeDetail.attributes['adopt-content'] : ''
      }
      this.$store.dispatch('PROPOSE_DETAIL', { id: this.$route.params.id, data: data, callback: callback })
    },
    goBack: function () {
      this.$router.push({path: '/propose_before_adopt_list/'})
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    },
    adopt: function () {
      if (window.confirm(this.$t('Adopt Confirm'))) {
        let data = {}
        const callback = () => {
          this.goBack()
        }
        if (this.validation.adopt_content && this.validation.adopt_rank) {
          data = {
            adopt_content: this.adoptedReason.content,
            adopt_rank: this.selectedRank
          }
          this.$store.dispatch('PROPOSE_ADOPT', { id: this.$route.params.id, data: data, callback: callback })
        }
      }
    },
    openModal: function () {
      this.isOpenModal = true
    },
    /** 画像押下 */
    onClickImageModalShow: function (number) {
      var button = document.getElementById('imageModalButton')
      var img = document.getElementById('imageModalImg')
      var text = document.getElementById('imageModalText')
      if (number === 1) {
        img.src = this.proposeDetail.attributes['propose-1-image-path'] + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
      } else if (number === 2) {
        img.src = this.proposeDetail.attributes['propose-2-image-path'] + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
      } else if (number === 3) {
        img.src = this.proposeDetail.attributes['propose-3-image-path'] + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
      }
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/propose-approved-detail.js